<template>
	<div>
		<div class="row content-header">
			<div class="content-header-left mb-2 col-md-12 col-12">
				<div class="row breadcrumbs-top">
					<div class="col-12">
						<h2 class="content-header-title float-left pr-1 mb-0">Dashboard</h2>
					</div>
				</div>
			</div>
		</div>

		<!-- Breed switcher -->
		<b-tabs class="breed-tabs m-2" nav-class="breed-tabs-nav">
			<b-tab v-if="showBroiler" :active="firstVisibleTab === 'Broiler'" title="Broiler">
				<BroilerDashboard />
			</b-tab>
			<b-tab v-if="showBreeder" lazy :active="firstVisibleTab === 'Breeder'" title="Breeder">
				<BreederDashboard />
			</b-tab>
			<b-tab v-if="showLayer" lazy :active="firstVisibleTab === 'Layer'" title="Layer">
				<LayerDashboard />
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
import {
	BCard,
	BRow,
	BCol,
	BFormInput,
	BFormGroup,
	BButton,
	BTable,
	BMedia,
	BAvatar,
	BLink,
	BBadge,
	BDropdown,
	BDropdownItem,
	BPagination,
	BTooltip,
	BTabs,
	BTab,
	BCardText,
	BFormDatepicker,
	BFormSelect,
	BImg,
} from "bootstrap-vue";

import vSelect from "vue-select";
import axiosIns from "@/libs/axios";
import BroilerDashboard from "../dashboard/BroilerDashboard.vue";
import BreederDashboard from "../dashboard/BreederDashboard.vue";
import LayerDashboard from "../dashboard/LayerDashboard.vue";

export default {
	components: {
		BCard,
		BRow,
		BCol,
		BFormInput,
		BFormGroup,
		BButton,
		BTable,
		BMedia,
		BAvatar,
		BLink,
		BBadge,
		BDropdown,
		BDropdownItem,
		BPagination,
		BTooltip,
		BCardText,
		BTabs,
		BTab,
		vSelect,
		BFormDatepicker,
		BFormSelect,
		BreederDashboard,
		LayerDashboard,
		BroilerDashboard,
		BImg,
	},
	data() {
		return {
			rows: null,
			allowedProductionTypeIds: [],
		};
	},
	computed: {
		// Empty allow-list = unrestricted company = show all three.
		showBroiler() {
			return this.allowedProductionTypeIds.length === 0 || this.allowedProductionTypeIds.includes(1);
		},
		showBreeder() {
			return this.allowedProductionTypeIds.length === 0 || this.allowedProductionTypeIds.includes(2);
		},
		showLayer() {
			return this.allowedProductionTypeIds.length === 0 || this.allowedProductionTypeIds.includes(3);
		},
		firstVisibleTab() {
			if (this.showBroiler) return "Broiler";
			if (this.showBreeder) return "Breeder";
			if (this.showLayer) return "Layer";
			return null;
		},
	},
	created() {
		axiosIns
			.get("web/production-types")
			.then((response) => {
				this.allowedProductionTypeIds = (response.data.production_type?.data || []).map((pt) => pt.id);
			})
			.catch(() => {
				// Fail open — don't hide tabs just because this call failed.
				this.allowedProductionTypeIds = [];
			});
	},
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss">
.breed-tabs {
	.breed-tabs-nav.nav-tabs {
		display: inline-flex;
		border: none;
		background: #f0eefb;
		border-radius: 12px;
		padding: 4px;
		gap: 4px;
		margin-bottom: 1.25rem;

		.nav-item {
			margin: 0;
		}

		.nav-link {
			border: none !important;
			border-radius: 8px;
			padding: 8px 22px;
			font-weight: 600;
			font-size: 13.5px;
			color: #6b6685;
			display: flex;
			align-items: center;
			transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

			&::after {
				display: none !important;
			}

			svg {
				color: currentColor;
			}

			&:hover:not(.active) {
				background: rgba(115, 103, 240, 0.08);
				color: #7367f0;
			}

			&.active {
				background: #7367f0;
				color: #fff;
				box-shadow: 0 4px 12px rgba(115, 103, 240, 0.28);
			}
		}
	}
}
</style>
